import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'wilson-calculate-working-time',
  template: `
    <span>
      <span class="text-dark"
        >{{ cellValue }}
        {{
          ('page.settings.working_time_models.hour' | translate) || '---'
        }}</span
      ><br />
    </span>
  `,
  standalone: false,
})
export class CalculateWorkingTimeRendererComponent
  implements AgRendererComponent
{
  public cellValue: string;

  agInit(params: ICellRendererParams) {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams) {
    this.cellValue = this.getValueToDisplay(params);
    return true;
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.value ?? 0;
  }
}
